module.exports = __webpack_public_path__ + "static/media/rabbit.6686eb7f.webp";